<template>
  <div
    v-show="productSize > 0"
    class="minicart"
    role="dialog"
    aria-modal="true"
    :aria-labelledby="miniFlyout.itemAdded === 'cart' ? 'flyout-title' : null"
  >
    <div
      class="minicart__header"
      :class="{'minicart__header--add' : miniFlyout.itemAdded === 'cart'}"
      ref="minicartHead"
      tabindex="-1"
    >
      <div v-if="miniFlyout.itemAdded !== 'cart'">
        {{ $t('global.minicart.cart') }}, {{ basketCount }} {{ $t('global.article.label') }}
      </div>
      <div
        v-else-if="miniFlyout.itemAdded === 'cart'"
        id="flyout-title"
        class="minicart__header--added"
      >
        {{ $t('global.add.message.cart') }}
      </div>
    </div>
    <div
      :class="[productSize >= 3 ? 'minicart__products-scroll' : 'minicart__products']"
      :id="`minicart`"
    >
      <template
        v-for="(product, index) in productsList"
        :key="index"
      >
      <product-order-position
        class="minicart__product-order-position"
        v-bind="product"
        :index="index"
        :flyout="true"
        :id="`minicart-${product.itemId}`"
        type="minicart"
      />
      </template>
      <configurator-order-position
        class="minicart__product-order-position"
        v-for="(configurator, index) in configuratorList"
        :key="`minicart-configurator-${index}`"
        v-bind="configurator"
        :id="`minicart-${configurator.entryId}`"
        type="minicart"
        :flyout="true"
      />
    </div>
    <div
      class="minicart__footer"
      :class="{
        'minicart__footer--many' : productSize >= 3
      }"
    >
      <div
        class="minicart__price-box"
      >
        <div
          class="minicart__footer-box"
          v-if="productsList.length > 0 && cartInfo != null && cartInfo.promotionResult.basketDiscountInfo"
        >
          <span class="minicart__discount">
            {{ $t('checkout.basket.invoiceDetails.discountAmount.headline') }}
          </span>
          <span class="minicart__discount">
            - {{ cartInfo.promotionResult.basketDiscountInfo.discount }}
          </span>
        </div>
        <div class="minicart__footer-box">
          <span class="minicart__shipping">
            {{ $t('ads.main.shipping.cost') }}
          </span>
          <span
            v-if="cartInfo != null"
            class="minicart__shipping"
            v-html="cartInfo.freeShipping.free ? $t('global.shipping.free.label') : cartInfo.promotionResult.deliveryResult.deliveryCost"
          />
        </div>
        <div class="minicart__footer-box">
          <span class="minicart__total">
            {{ $t('global.order.total') }} <small>({{ $t('global.inclVAT') }})</small>
          </span>
          <span
            v-if="cartInfo != null"
            class="minicart__total"
          >
            {{ cartInfo.promotionResult.totalNet }}
          </span>
        </div>
      </div>
      <a
        class="minicart__button | button button--size_40"
        :href="'/basket/'"
        @blur="$emit('close-flyout')"
      >
        {{ $t('global.to_basket') }}
      </a>
    </div>
  </div>
</template>

<script>
  import globalStateComputedMixin from '../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin.js';
  import ProductOrderPosition from "../productOrderPosition/productOrderPosition";
  import ConfiguratorOrderPosition from "../configuratorOrderPosition/configuratorOrderPosition";
  import VueScrollTo from 'vue-scrollto'

  export default {
    mixins: [
      globalStateComputedMixin
    ],
    components: {
      ProductOrderPosition,
      ConfiguratorOrderPosition
    },
    data() {
      return {
        scroll: '',
        mutationType: ''
      }
    },
    mounted() {
      this.$store.subscribe(mutation => {
        if (mutation.type === 'showMinicart') {
          this.mutationType = mutation.payload.type;
          this.scroll = 'mini' + this.mutationType + '-' + mutation.payload.itemId;
        }
      });
    },
    updated() {
      if (this.pageType !== 'cart' && this.mutationType === 'cart') {
        if (this.scroll) {
          let elementToBeScrolledTo = document.getElementById(this.scroll);
          VueScrollTo.scrollTo(elementToBeScrolledTo, 1000, {
            container: '#minicart',
            cancelable: true,
            onDone: () => this.scroll = ''
          })
        }
      }
    },
    computed: {
      productsList() {
        if (this.cart != null) {
          return this.cart.shipmentPositions.flatMap(pos => pos.positions);
        }
        return [];
      },
      configuratorList() {
        if (this.cart != null) {
          return this.cart.configuratorPositions;
        }
        return [];
      },
      productSize() {
        let positions = this.productsList.length;
        let configurators = this.configuratorList.length;
        return positions + configurators;
      },
      cartInfo() {
        return this.cart
      },
      itemAdded() {
        return this.$store.state.miniFlyout.itemAdded;
      },
    },
    watch: {
      itemAdded(newVal) {
        if (newVal !== null && this.productSize > 0) {
          this.$nextTick(() => {
            if (this.$refs.minicartHead) {
              this.$refs.minicartHead.focus();
            }
          });
        }
      }
    },
  };

</script>
